import { gql } from '@apollo/client';

export const createWishList = gql`
  mutation CreateWishList(
    $input: CreateWishListInput!
    $condition: ModelWishListConditionInput
  ) {
    createWishList(input: $input, condition: $condition) {
      id
      name
      userID
      createdAt
      updatedAt
      wishListStudios {
        items {
          id
          wishListID
          studioID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`

export const updateWishList = gql`
  mutation UpdateWishList(
    $input: UpdateWishListInput!
    $condition: ModelWishListConditionInput
  ) {
    updateWishList(input: $input, condition: $condition) {
      id
      name
      userID
      createdAt
      updatedAt
      wishListStudios {
        items {
          id
          wishListID
          studioID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`

export const deleteWishList = gql`
  mutation DeleteWishList(
    $input: DeleteWishListInput!
    $condition: ModelWishListConditionInput
  ) {
    deleteWishList(input: $input, condition: $condition) {
      id
      name
      userID
      createdAt
      updatedAt
      __typename
    }
  }
`

export const createWishListStudio = gql`
  mutation CreateWishListStudio(
    $input: CreateWishListStudioInput!
    $condition: ModelWishListStudioConditionInput
  ) {
    createWishListStudio(input: $input, condition: $condition) {
      id
      wishListID
      studioID
      createdAt
      updatedAt
      __typename
    }
  }
`

export const updateWishListStudio = gql`
  mutation UpdateWishListStudio(
    $input: UpdateWishListStudioInput!
    $condition: ModelWishListStudioConditionInput
  ) {
    updateWishListStudio(input: $input, condition: $condition) {
      id
      wishListID
      studioID
      createdAt
      updatedAt
      __typename
    }
  }
`

export const deleteWishListStudio = gql`
  mutation DeleteWishListStudio(
    $input: DeleteWishListStudioInput!
    $condition: ModelWishListStudioConditionInput
  ) {
    deleteWishListStudio(input: $input, condition: $condition) {
      id
      wishListID
      studioID
      createdAt
      updatedAt
      __typename
    }
  }
`